var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaunchingIcon2(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 151.278,
    height: 123.872,
    viewBox: "0 0 151.278 123.872",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-check_1_",
    "data-name": "user-check (1)",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M97.56,53.624V40.749A25.749,25.749,0,0,0,71.811,15H26.749A25.749,25.749,0,0,0,1,40.749V53.624",
    transform: "translate(-1 62.248)",
    fill: "none",
    stroke: "#5090bb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_100",
    "data-name": "Ellipse 100",
    cx: 25.749,
    cy: 25.749,
    rx: 25.749,
    ry: 25.749,
    transform: "translate(22.53 0)",
    fill: "none",
    stroke: "#5090bb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    d: "M17,21.875,29.875,34.749,55.624,9",
    transform: "translate(85.997 29.624)",
    fill: "none",
    stroke: "#5090bb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunchingIcon2);
export default __webpack_public_path__ + "static/media/launching-icon2.362b9749f78f68d9563c2bf6d926672a.svg";
export { ForwardRef as ReactComponent };